import { __assign } from "tslib";
/* eslint react/display-name: 0 */
import * as React from 'react';
import { translate } from '@wix/wixstores-client-core';
import * as _ from 'lodash';
function getTranslation(translations) {
    return function (translationKey, values) {
        return translate(translations[translationKey], values);
    };
}
export var withTranslations = function (textsMapProp) {
    if (textsMapProp === void 0) { textsMapProp = 'globals.textsMap'; }
    return function (Component) {
        return React.forwardRef(function (props, ref) {
            return React.createElement(Component, __assign({}, props, { ref: ref, t: getTranslation(_.get(props, textsMapProp)) }));
        });
    };
};
//# sourceMappingURL=translations.js.map